import { Form, Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa6';
import { useFormikContext } from 'formik';
import ReactDataTable from '../../../ReactDataTable/ReactDataTable';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import DeleteSingleItems from '../../../Modal/DeleteSingleItems';

const QuickLinkList = ({ arrayHelpers }) => {
    const { values, setFieldValue } = useFormikContext();
    const columns = [
        {
            name: 'Title',
            cell: (_, i) => <ReactInput name={`quickLinkData[${i}.title]`} />,
        },
        {
            name: 'Link',
            cell: (_, i) => <ReactInput name={`quickLinkData[${i}.link]`} />,
        },
        {
            name: 'New Tab',
            center: 'true',
            cell: (row, i) => (
                <Form.Check
                    checked={row?.new_tab === 1}
                    onChange={(e) =>
                        setFieldValue(`quickLinkData[${i}].new_tab`, e.target.checked ? 1 : 0)
                    }
                />
            ),
        },
        {
            name: 'Status',
            center: 'true',
            cell: (row, i) => (
                <Form.Check
                    checked={row?.status === 1}
                    onChange={(e) =>
                        setFieldValue(`quickLinkData[${i}].status`, e.target.checked ? 1 : 0)
                    }
                />
            ),
        },
        {
            name: 'Remove',
            center: 'true',
            cell: (_, i) => <DeleteSingleItems handleDelete={() => arrayHelpers.remove(i)} />,
        },
    ];

    return (
        <div>
            <div className='d-flex justify-content-between align-items-center mb-3'>
                <h5>Quick Link</h5>
                <Button
                    variant='teal'
                    onClick={() =>
                        arrayHelpers.push({
                            title: '',
                            link: '',
                            new_tab: 1,
                            status: 1,
                        })
                    }
                >
                    <FaPlus />
                </Button>
            </div>
            <ReactDataTable columns={columns} data={values.quickLinkData} />
        </div>
    );
};

export default QuickLinkList;
